module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAgCAYAAABgrToAAAAAAXNSR0IArs4c6QAAAUZJREFUWEft1j9OwzAUBvD32plbVEikF+DPDgEWFhYcKnEOMlSqYOEQiKpd2GChPUgbDsJafyiugIo2jWLnPWWo10j2L5/jz2Fq+OCG+2gHDN0h0QQ/zxNjLZ0eHHXuuN+3Plgx4Cw2CRO/AGgR8zg67PR8kGLA7KJ3A7sYAtR2yXkixYC5qQ6kKLAOpDgwFKkCDEGqAX2RqkAf5BoQ16/LWhAc2de7IdCz68iSCloDzs4MBG3FUxf0ZHOAjt6+6k6Hb6tvsQmYaSTIzPu/W5xfNC1Ko4/xw/+11Q9JDpjHZgBQ+oMpwrnPUyOt1TWq4NSBVXGqQB+cGtAXpwIMwYkDQ3GiwHl8mwJ28HeC+b47HT1WbQ2xmskuk2MsaAJgb1vPlYHFgO7PZYk8iSajpzJI0XNRoC9q611cx6R1zrFLMDTNxif4DelrxiGcIt//AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active_go.png
// module id = 9MsD
// module chunks = 1